import React from "react";
import { ICidade } from "../interface";
import './styles.css';
import { Card, Col, ListGroup } from 'react-bootstrap';

interface CardResultadoProps {
  selecaoCidade:ICidade;
  index:number;
}
const CardResultado:React.FC<CardResultadoProps> = ({selecaoCidade, index}) => {
    return(
      <Col sm={4} className="colCard p-2" key={index}>
        <Card className="h-100">
          <Card.Body>
            <ListGroup variant="flush">
              <ListGroup.Item><strong>Cidade:</strong> {selecaoCidade.nome}</ListGroup.Item>
              <ListGroup.Item><strong>UF:</strong> {selecaoCidade.sigla_uf}</ListGroup.Item>
              <ListGroup.Item><strong>Código IBGE:</strong> {selecaoCidade.codigo_ibge}</ListGroup.Item>
              <ListGroup.Item><strong>Dados obrigatórios das notas tomadas:</strong> {selecaoCidade.dados_obrigatorios_tomadas}</ListGroup.Item>
            </ListGroup>
            <div className="mt-3">
              <span className="me-2">Notas tomadas
                {selecaoCidade.notas_tomadas ? 
                  <span className="text-success">✔</span> 
                : <span className="text-danger">❌</span>}
              </span>

              <span className="me-2">Múltiplos serviços
                {selecaoCidade.multiservicos ? 
                  <span className="text-success">✔</span> 
                : <span className="text-danger">❌</span>}
              </span>
              <span className="me-2">Login 
                {selecaoCidade.login ? 
                  <span className="text-success">✔</span> 
                : <span className="text-danger">❌</span>}
              </span>
              <span className="me-2">Senha 
                {selecaoCidade.senha ? 
                  <span className="text-success">✔</span> 
                : <span className="text-danger">❌</span>}
              </span>
              <span className="me-2">Certificado 
                {selecaoCidade.certificado ? 
                  <span className="text-success">✔</span> 
                : <span className="text-danger">❌</span>}
              </span>
            </div>
          </Card.Body>
        </Card>
      </Col>
    )
};
export default CardResultado;